import React, {useEffect, useState} from "react";
import {
    getChecklistRevision,
    addChecklistRevision,
    editChecklistRevision,
    activateChecklistRevision, downloadChecklistRevision, downloadAllChecklistRevisions, getTaskTypes, getTaskLinksHost, getTaskLinks
} from 'api';
import {Button as AntdButton, Button, Form, Input, Table, Tabs, Tag} from "antd";
import { Col, Row } from 'react-flexbox-grid';
import {Dropdown, DropdownButton} from "react-bootstrap";
import {ExclamationCircleOutlined, SearchOutlined} from "@ant-design/icons";
import {confirmAlert} from "react-confirm-alert";
import TaskSymbols from "./TaskSymbols";
import AddEditRevisionForm from "./AddEditRevisionForm";
import SpinnerNew from "../../Spinner/SpinnerNew";
import {isAdministrator} from "../../../utils/UserInfo";
import {
    commonSorter,
    SearchAndDropdownComponent,
    searchAndDropDownFilters,
    searchAndDropDownOnFilters
} from "../../../utils/AntdTableFunctions";
import TextArea from "antd/es/input/TextArea";

function TaskRevisions(props){
    const {checklistId, checklistName, taskGroup, revisionNo, revisionStatus, refreshChecklistData, taskTypes} = props;
    const [revision, setRevision] = useState(null);
    const [taskRevisions,setTaskRevisions] = useState([]);
    const [saveDisable, setSaveDisable] = useState(true);
    const [displayRev, setDisplayRev] = useState(props.revisionNo);
    const [displayStatus, setDisplayStatus] = useState(props.revisionStatus);
    const [nextPos, setNextPos] = useState(null);
    const [spinnerOn, setSpinnerOn] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [linkHost, setLinkHost] = useState(null);
    const [baseTaskRevisions, setBaseTaskRevisions] = useState([]);
    const [checkListTaskTypes, setCheckListTaskTypes] = useState([]);
    const [tableTasks, setTableTasks] = useState([]);
    const [defTypeId, setDefTypeId] = useState(null);
    const [disabledTaskLinks, setDisabledTaskLinks] = useState([]);

    useEffect(() => {
        async function getData() {
            setSpinnerOn(true);
            let links = await getTaskLinks();
            let disableIds = [];
            links.data.filter(t=>t.disableFlag==='Y').map((t)=>
            {
                disableIds.push(t.linkId);
            });
            setDisabledTaskLinks(disableIds);
            let host = await getTaskLinksHost();
            setLinkHost(host);
            let response = await getChecklistRevision(checklistId, revisionNo);
            let baseTasks = []
            setRevision(response.data);
            if(revisionStatus === 'D')
            {
                let baseRev = response.data.baseRevisionNo;
                let response1 = await getChecklistRevision(checklistId, baseRev);
                baseTasks = response1.data.revisionTasks;
                setBaseTaskRevisions(baseTasks);
            }
            if(revisionStatus === 'N')
            {
                baseTasks = response.data.revisionTasks;
                setBaseTaskRevisions(baseTasks);
            }
            let newTasks = resetRevisionTasks(response.data.revisionTasks, baseTasks);
            let sortedTypes = resetTaskType();
            setTableTasks(newTasks.filter(k => k.taskTypeId===sortedTypes[0].typeId));
            setDefTypeId(sortedTypes[0].typeId);
            setSpinnerOn(false);
        }
        setSaveDisable(revisionStatus!=='N');
        setDisplayRev(props.revisionNo);
        setDisplayStatus(props.revisionStatus);
        getData();
        
    }, [checklistId,revisionNo, revisionStatus,refresh]);

    function resetTaskType()
    {
        let sortedTypes = taskTypes.map((type) =>
        {
            return{typeId: type.typeId, taskType: type.taskType,
            orderId: (taskGroup==='PR' && checklistId===28) ? type.preJobOrder:
                ((taskGroup==='PR' && checklistId===29) ? type.postJobOrder :
                    ((taskGroup==='PR' && checklistId===30) ? type.removalsOrder :
                        ((taskGroup==='PR' && checklistId===31) ? type.cipOrder :
                            (taskGroup==='AT' ? type.assetTaskOrder :
                            type.formTaskOrder))))};
        }).filter(t =>t.orderId!==null).sort(
            function(a,b){
                return (a?.orderId-b?.orderId); //if(a.orderId!==null && b.orderId!==null) return (a?.orderId-b?.orderId);
                //if(a.orderId===null && b.orderId===null) return a.taskType.toLowerCase().localeCompare(b.taskType.toLowerCase());
                //return true;
                //if(b.orderId===null) return true;
            }
        );
        setCheckListTaskTypes(sortedTypes);
        return sortedTypes;
    }
    function compareRoles(a,b)
    {
        if(a.length!==b.length)
            return false;
        return true;
    }
    function resetRevisionTasks(tasks, baseTasks)
    {
        console.log('TASK',tasks);
        let newTasks = tasks.sort(
        function(a,b){ if(a.taskTypeId===b.taskTypeId)
                    return (a.taskSerialNo-b.taskSerialNo);
                    else return (a.taskTypeId-b.taskTypeId);
        }).map((t, i)=>
        {
            let sy = TaskSymbols.filter(k=>k.fileId===t.fileId);
            let types = taskTypes.filter(k=>k.typeId===t.taskTypeId);
            let bTasks = baseTasks.filter(k => k.taskMasterId===t.taskMasterId);
            return {...t, pos: i, maxCnt: tasks.filter(k=>k.taskTypeId===t.taskTypeId).length, taskSymbol: sy.length > 0 ? sy[0].desc : '',
                taskType: types.length>0 ? types[0].taskType : '',
                roles: t.taskRoles.map((role)=>role.roleName).join(','),
                links: t.taskLinks.map((link)=>link.linkTitle).join(','),
                taskIdDiff:revisionStatus==='A'?true:bTasks.length>0,
                taskNoDiff:revisionStatus==='A'?true:(bTasks.length>0 && bTasks[0].taskSerialNo===t.taskSerialNo),
                taskDescDiff:revisionStatus==='A'?true:(bTasks.length>0 && bTasks[0].taskDesc===t.taskDesc),
                taskSyDiff:revisionStatus==='A'?true:(bTasks.length>0 && bTasks[0].fileId===t.fileId),
                taskRoles: t.taskRoles.map((k)=> {
                    let roleDiff = true;
                    if(revisionStatus !=='A' && bTasks.length>0){
                        let bRole = bTasks[0].taskRoles.filter(r=>r.roleId===k.roleId);
                        roleDiff = bRole.length > 0;
                    } 

                    return {...k, roleDiff:roleDiff};
                }),
                taskLinks: t.taskLinks.map((k)=> {                    
                    let linkDiff = true;
                    if(revisionStatus!=='A' && bTasks.length>0){
                        let bLink = bTasks[0].taskLinks.filter(r=>r.linkId===k.linkId);
                        linkDiff = bLink.length>0;
                    }
                    return {...k,linkDiff:linkDiff};
                }),
                taskActions: t.taskActions.map((k)=> {
                    let actionDiff = true;
                    if(revisionStatus!=='A' && taskGroup==='AT' && bTasks.length>0){
                        let bAction = bTasks[0].taskActions.filter(r=>r.actionCode===k.actionCode);
                        actionDiff = bAction.length>0;
                    }
                    return {...k, actionDiff:actionDiff};
                })
            };
        });   
        setNextPos(newTasks.length);
        setTaskRevisions(newTasks);
        console.log('newTasks', newTasks);
        return newTasks;
    }
    function getNextPos()
    {
        let pos = nextPos;
        setNextPos(pos+1);
        return pos;
    }
    function AddEditTaskFormatter(cell, row, action)
    {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <AddEditRevisionForm action={action} task={row} onClose={onClose} taskRevisions={taskRevisions} taskGroup={taskGroup}
                                         revisionStatus={revisionStatus} resetRevisionTasks={resetRevisionTasks} baseTasks={baseTaskRevisions} setSaveDisable={setSaveDisable}
                                         taskTypes={checkListTaskTypes} setTableTasks={setTableTasks} setDefTypeId={setDefTypeId}/>
                );
            }
        });
    }
    function TaskIDFormatter(cell,row)
    {
        let c = row.taskIdDiff?'black':'red';
        if(row.taskMasterId !== null)
            return (<div style={{color:c}}>{row.taskMasterId}</div>);
        else return (<div style={{color:'red'}}>NEW</div>);
    }
    function TaskActionFormatter(cell, row)
    {
        return (
            <ul>
                {row.taskActions.map((action, index) => (
                    getActionFormatter(action)
                ))}
            </ul>
        );
    }
    function getActionFormatter(action)
    {
        let c = action.actionDiff ? 'black':'red';
        return (
            <li key={action.actionCode} style={{color:c}}>{action.actionCode}</li>
        );
    }
    function TaskRolesFormatter(cell, row)
    {
        return (
            <ul>
                {row.taskRoles.map((role,index) => (
                    getRoleFormatter(role)
                ))}
            </ul>
        );
    }
    function getRoleFormatter(role)
    {
        let c = role.roleDiff ? 'black':'red';
        return (
            <li key={role.roleId} style={{color:c}}>{role.roleName}</li>
        );
    }
    function TaskLinksFormatter(cell, row)
    {
        return (
            <ul>
                {row.taskLinks.map((link) => (
                    getLinkFormatter(link)
                ))}
            </ul>
        );
    }
    function getLinkFormatter(link)
    {
        let disableLink = disabledTaskLinks.includes(link.linkId) ? 'line-through': 'none';
        let pointerEvent = disabledTaskLinks.includes(link.linkId) ? 'none': 'auto';
        let c = link.linkDiff ? 'black':'red';
        let cc = link.linkDiff ? 'default':'red';
        return (
            <li key={link.linkId} style={{color:c}}><a style={{color:cc, textDecoration: disableLink, pointerEvents: pointerEvent}} href={link.link.slice(0,4)==='http' ? link.link : linkHost+link.link} target='_blank'>{link.linkTitle}</a></li>
        );
    }
    function TaskSymbolFormatter(cell, row) {
        let sy = TaskSymbols.filter(t => t.fileId === row.fileId);
        if (sy.length > 0) {
            let c = row.taskSyDiff?'black':'red';
            return (<div style={{color:c}}>{sy[0].image}{' '}{sy[0].desc}</div>);
        }
        else
            return (<></>);
    }

    function TaskDescFormatter(cell,row)
    {
        let c = row.taskDescDiff?'black':'red';
        return (<TextArea style={{color:c}} value={row.taskDesc} autoSize={true} readOnly={true} bordered={false}/>)
    }
    function TaskNoFormatter(cell,row)
    {
        let c = row.taskNoDiff?'black':'red';
        return (<div style={{color:c}}>{row.taskSerialNo}</div>)
    }
    function DeleteCellFormatter(cell,row)
    {
        let arr = [];
        let no = row.taskSerialNo;
        let typeId = row.taskTypeId;
        let found = false;
        for(let index=0; index<taskRevisions.length; ++index)
        {
            if(taskRevisions[index].pos !== row.pos) {
                if(found === true && taskRevisions[index].taskTypeId === typeId)
                {
                    let task = {...taskRevisions[index], taskSerialNo: taskRevisions[index].taskSerialNo-1, editFlag:'E'};
                    arr.push(task);
                }
                else
                    arr.push(taskRevisions[index]);
            }
            else
                found = true;
        }
        let newTasks = resetRevisionTasks(arr, baseTaskRevisions);
        setTableTasks(newTasks.filter(k => k.taskTypeId===typeId).sort(function(a,b){return a.taskSerialNo-b.taskSerialNo}));
        setSaveDisable(false);
    }

    function showActivateConfirm() {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <div className="react-confirm-alert-body">
                        <h4>Warning: A New Task Revision will be made effective.</h4>
                        <p>When activating a new Task Revision, tasks on Active Checklists will be updated to the new revision only if no tasks within that Checklist Section, for a given asset, have been <b>Signed</b>, <b>Marked as N/A</b>, or <b>Marked Temp</b> <u>by a user</u>.
                            If any task within a Checklist Section has already been marked, the previous task revision will remain in effect for that section/asset.
                            Do you want to proceed?
                        </p><br/>
                        <Button style={{height: 'auto'}} type='primary'
                                onClick={async ()=>
                                {
                                    setSpinnerOn(true);
                                    let response = await activateChecklistRevision(checklistId, displayRev);
                                    if(response.status === 'SUCCESS')
                                    {
                                        setDisplayRev(response.data.revisionNo);
                                        setDisplayStatus(response.data.revisionStatus);
                                        setRevision(response.data);
                                        resetRevisionTasks(response.data.revisionTasks, baseTaskRevisions);
                                        refreshChecklistData();
                                    }
                                    setSpinnerOn(false);
                                    onClose();
                               }}
                        >Yes</Button>
                        <Button style={{height: 'auto'}} type='primary' onClick={()=>{onClose();}}>No</Button>
                    </div>
                );
            }
        });
    }
    function showActiveSaveConfirm() {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <div className="react-confirm-alert-body">
                        <h4><p style={{color:'red'}}>Warning: Changing Active Revision will affect existing Tasks display.</p></h4>
                        <p>Do you want to proceed?</p><br/>
                        <Button style={{height: 'auto'}} type='primary'
                                onClick={async ()=>
                                {
                                    let response = await editChecklistRevision({
                                        id: {checklistId: checklistId, revisionNo: displayRev},
                                        revisionTasks: taskRevisions
                                    });
                                    if(response.status === 'SUCCESS') {
                                        resetRevisionTasks(response.data, baseTaskRevisions);
                                    }
                                    onClose();
                                }}
                        >Yes</Button>
                        <Button style={{height: 'auto'}} type='primary' onClick={()=>{setRefresh(!refresh);onClose()}}>No</Button>
                    </div>
                );
            }
        });
    }
    function MoveDownFormatter(cell, row)
    {
        let arr = [];
        let index = -1000;
        let typeId = row.taskTypeId;
        console.log('taskRevisions:movedown',taskRevisions);
        console.log('row',row);
        for(let i=0; i<taskRevisions.length; ++i)
        {
            if(taskRevisions[i].pos === row.pos && taskRevisions[i].taskTypeId===typeId) {
                index = i;
                continue;
            }
            if(i === (index+1)) continue;
            arr.push(taskRevisions[i]);
        }
        arr.push({...taskRevisions[index], taskSerialNo: (taskRevisions[index].taskSerialNo)+1, editFlag:'E'});
        arr.push({...taskRevisions[index+1], taskSerialNo: taskRevisions[index].taskSerialNo, editFlag:'E'});
        let newTasks = resetRevisionTasks(arr, baseTaskRevisions);
        setTableTasks(newTasks.filter(k => k.taskTypeId===typeId).sort(function(a,b){return a.taskSerialNo-b.taskSerialNo}));
        setSaveDisable(false);
    }
    function MoveUpFormatter(cell, row)
    {
        let arr = [];
        let index = -1000;
        let typeId = row.taskTypeId;
        for(let i=taskRevisions.length-1; i>=0; --i)
        {
            if(taskRevisions[i].pos === row.pos && taskRevisions[i].taskTypeId===typeId) {
                index = i;
                continue;
            }
            if(i === (index-1)) continue;
            arr.push(taskRevisions[i]);
        }
        arr.push({...taskRevisions[index], taskSerialNo: (taskRevisions[index].taskSerialNo)-1, editFlag:'E'});
        arr.push({...taskRevisions[index-1], taskSerialNo: taskRevisions[index].taskSerialNo, editFlag:'E'});
        let newTasks = resetRevisionTasks(arr, baseTaskRevisions);
        setTableTasks(newTasks.filter(k => k.taskTypeId===typeId).sort(function(a,b){return a.taskSerialNo-b.taskSerialNo}));
        setSaveDisable(false);
    }
    const getFilterDrop = ({
                               setSelectedKeys,
                               selectedKeys,
                               confirm,
                               clearFilters,
                           }) =>
    {
        return (
            <div className='custom-filter-dropdown' style={{ padding: '8px' }}>
                <Input
                    autoFocus
                    placeholder='Search'
                    value={selectedKeys[0]}
                    onChange={(e) => {
                        e.preventDefault();
                        setSelectedKeys(e.target.value ? [e.target.value] : []);
                    }}
                    onPressEnter={() => {
                        confirm();
                    }}
                />
                <div>
                    <AntdButton
                        size='small'
                        type='primary'
                        style={{ width: 90, marginRight: 8 }}
                        onClick={() => {
                            confirm();
                        }}
                    >
                        Search
                    </AntdButton>
                    <AntdButton
                        size='small'
                        onClick={() => {
                            clearFilters();
                        }}
                        style={{ width: 90 }}
                    >
                        Reset
                    </AntdButton>
                </div>
            </div>
        );
    }

    const taskColumns = [
        {
            dataIndex: 'pos',
            key: 'pos',
            width: '5%',
            title: 'Action',
            hidden: !isAdministrator() || !(displayStatus==='D' || displayStatus==='N'),
            render: (cell, row) => (
                <DropdownButton id={`${row.id}-dropdown`} title='' style={{width: '100%', position: 'inherit'}}>
                    <Dropdown.Item onClick={() => AddEditTaskFormatter(cell, row, 'Edit')}>Edit</Dropdown.Item>
                    <Dropdown.Item onClick={() => DeleteCellFormatter(cell, row)}>Remove</Dropdown.Item>
                    {row.taskSerialNo>1 && <Dropdown.Item onClick={() => MoveUpFormatter(cell, row)}>Move Up</Dropdown.Item>}
                    {row.taskSerialNo<row.maxCnt && <Dropdown.Item onClick={() => MoveDownFormatter(cell, row)}>Move Down</Dropdown.Item>}
                </DropdownButton>
            )
        },
        {
            title: 'Task ID',
            dataIndex: 'taskMasterId',
            width: '7%',
            key: 'taskMasterId',
            render: TaskIDFormatter,
            sorter: (a,b) => commonSorter(a,b,'taskMasterId'),
            //filters: searchAndDropDownFilters('taskMasterId', taskRevisions),
            //...SearchAndDropdownComponent(),
            //onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'taskMasterId'),
        },
        {
            title: 'Task Type',
            dataIndex: 'taskType',
            key: 'taskType',
            hidden: true,
            //render: TaskTypeFormatter
        },
        {
            title: 'Task No',
            width: '7%',
            dataIndex: 'taskSerialNo',
            key: 'taskSerialNo',
            sorter: (a,b) => commonSorter(a,b,'taskSerialNo'),
            render: TaskNoFormatter
        },
        {
            title: 'Description',
            width: '28%',
            dataIndex: 'taskDesc',
            key: 'taskDesc',
            render: TaskDescFormatter,
            //filters: searchAndDropDownFilters('taskDesc', taskRevisions),
            //...SearchAndDropdownComponent(),
            //onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'taskDesc'),
            filterDropdown: getFilterDrop,
            filterIcon: () => {
                return <SearchOutlined />;
            },
            onFilter: (value, record) => {
                return record.taskDesc.toLowerCase().includes(value.toLowerCase());
            },
        },
        {
            title: 'Roles',
            dataIndex: 'taskRoles',
            key: 'role',
            width: '10%',
            render: TaskRolesFormatter,
            filters: searchAndDropDownFilters('roles', taskRevisions),
            ...SearchAndDropdownComponent(),
            onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'roles'),
        },
        {
            title: 'Symbol',
            dataIndex: 'fileId',
            key: 'fileId',
            width: '10%',
            render: TaskSymbolFormatter,
            sorter: (a,b) => commonSorter(a,b,'taskSymbol'),
            filters: searchAndDropDownFilters('taskSymbol', taskRevisions),
            ...SearchAndDropdownComponent(),
            onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'taskSymbol'),
        },
        {
            title: 'Links',
            dataIndex: 'taskLinks',
            key: 'links',
            render: TaskLinksFormatter,
            //filters: searchAndDropDownFilters('links', taskRevisions),
            //...SearchAndDropdownComponent(),
            //onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'links'),
        filterDropdown: getFilterDrop,
            filterIcon: () => {
                return <SearchOutlined />;
            },
            onFilter: (value, record) => {
                return record.links.toLowerCase().includes(value.toLowerCase());
            },
        },
        {
            title: 'IPS Actions',
            dataIndex: 'taskActions',
            key: 'pos',
            width: '10%',
            hidden : (taskGroup !== 'AT'),
            render: TaskActionFormatter
        }
    ];

    const getTabPane = (type) =>
    {
        let tasks = taskRevisions.filter(t => t.taskTypeId===type.typeId);
        return ( tasks.length>0 &&
            <Tabs.TabPane tab={type.taskType} key={'taskType_'+type.typeId}>
            </Tabs.TabPane>
        )
    }

    return (
        <div className="container-fluid">
            <SpinnerNew display={spinnerOn}/>
            <Row>
                <Col xs={2} md={2} lg={2} style={{ textAlign: 'left' }}>
                    <div><b>{'Checklist Section: '}</b>{checklistName}</div>
                    <div><b>{'Version: '}</b>{displayStatus === 'A' ? displayRev :
                        (displayStatus === 'D' ?(displayRev+'-DRAFT'):(displayRev+'-NEW'))}</div>
                </Col>

                {displayStatus === 'A' &&
                <Col xs={2} md={2} lg={2} style={{textAlign: 'left'}}>
                        <div><b>{'Set Active On: '}</b>{revision?.modifiedDate}</div>
                        <div><b>{'Set Active By: '}</b>{revision?.modifiedBy}</div>
                </Col>
                }
                {displayStatus === 'D' &&
                <Col xs={2} md={2} lg={2} style={{textAlign: 'left'}}>
                        <div><b>{'Created On: '}</b>{revision?.createdDate}</div>
                        <div><b>{'Created By: '}</b>{revision?.createdBy}</div>
                </Col>
                }
                {displayStatus === 'D' &&
                <Col xs={2} md={2} lg={2} style={{textAlign: 'left'}}>
                    <div><b>{'Modified On: '}</b>{revision?.modifiedDate}</div>
                    <div><b>{'Modified By: '}</b>{revision?.modifiedBy}</div>
                </Col>
                }
                <Col>
                    {isAdministrator() && displayStatus!=='A' &&
                        <Button
                        style={{height: 'auto'}}
                        type='primary'
                        onClick={() => AddEditTaskFormatter(null, {taskMasterId:null,revisionNo:revisionNo,checklistSectionId:checklistId,
                                taskTypeId:null,taskSerialNo:0,pos:getNextPos(),taskRoles:[],taskLinks:[], taskActions:[]}, 'Add')}
                        >
                        Add New Task
                        </Button>
                    }
                    {isAdministrator() &&
                    <Button
                        style={{height: 'auto'}}
                        type='primary'
                        onClick={async () => {
                            setSpinnerOn(true);
                            if (displayStatus === 'N') {
                                let response = await addChecklistRevision({
                                    id: {checklistId: checklistId, revisionNo: -1},
                                    baseRevisionNo: displayRev,
                                    revisionTasks: taskRevisions
                                });
                                if (response.status === 'SUCCESS') {
                                    setDisplayRev(response.data.revisionNo);
                                    setDisplayStatus(response.data.revisionStatus);
                                    setRevision(response.data);
                                    let newTasks = resetRevisionTasks(response.data.revisionTasks, baseTaskRevisions);
                                    setTableTasks(newTasks.filter(k => k.taskTypeId===defTypeId).sort(function(a,b){return a.taskSerialNo-b.taskSerialNo}));
                                    refreshChecklistData();
                                }
                            }
                            else
                            {
                                let response = await editChecklistRevision({
                                    id: {checklistId: checklistId, revisionNo: displayRev},
                                    revisionTasks: taskRevisions
                                });
                                if (response.status === 'SUCCESS') {
                                    setRevision(response.data);
                                    let newTasks = resetRevisionTasks(response.data.revisionTasks, baseTaskRevisions);
                                    setTableTasks(newTasks.filter(k => k.taskTypeId===defTypeId).sort(function(a,b){return a.taskSerialNo-b.taskSerialNo}));
                                }
                            }
                            setSpinnerOn(false);
                            setSaveDisable(true);
                        }}
                        disabled={saveDisable}
                    >
                        {displayStatus === 'N' ? 'Save as a Draft' : 'Save Changes'}
                    </Button>
                    }
                    {isAdministrator() && displayStatus === 'D' && saveDisable===true &&
                    <Button
                        style={{height: 'auto'}}
                        type='primary'
                        onClick={async () => {
                            showActivateConfirm();
                        }}
                    >
                        Activate Draft to Current
                    </Button>
                    }
                    {displayStatus !== 'N' && saveDisable===true &&
                    <><Button
                        style={{height: 'auto'}}
                        type='primary'
                        onClick={async () => {
                            setSpinnerOn(true);
                            await downloadChecklistRevision(checklistId, revisionNo, checklistName);
                            setSpinnerOn(false);
                        }}
                    >
                        Export to Excel
                    </Button>
                    {'   '}
                        <Button
                        style={{height: 'auto'}}
                        type='primary'
                        onClick={async () => {
                        setSpinnerOn(true);
                        await downloadAllChecklistRevisions();
                        setSpinnerOn(false);
                    }}
                        >
                        Export All Current Versions
                        </Button>
                    </>
                    }
                </Col>
            </Row>
            <div>
                <Tabs onTabClick={(key) => onTabClick(key)} activeKey={'taskType_'+defTypeId}>
                    {
                        checkListTaskTypes.map((t) =>
                            getTabPane(t)
                        )
                    }
                </Tabs>
                <Table
                    bordered
                    dataSource={tableTasks}
                    columns={taskColumns.filter(t=>!t.hidden)}
                    pagination={false}
                    rowKey={(record)=>record.taskMasterId+'-'+record.taskSerialNo}
                    //scroll={{ y: '100%'}}
                />

            </div>
        </div>
    )

    function onTabClick(key)
    {
       let typeId = Number(key.substr(9));
       setDefTypeId(typeId);
       setTableTasks(taskRevisions.filter(t=>t.taskTypeId===typeId));
    }
}
export default TaskRevisions;